
function inferApiBase() {
  if (typeof window === 'undefined') {
    return 'http://localhost:3001';
  }
  const host = window.location?.hostname || 'localhost';
  const isLocal = host === 'localhost' || host === '127.0.0.1';
  return isLocal ? `http://${host}:3001` : 'https://api.agilepro.ai';
}

export class SearchGateway {
  constructor({ fetch, apiBase, endpoint = '/api/search-chats' } = {}) {
    const fetchImpl = typeof fetch === 'function' ? fetch : (typeof window !== 'undefined' && typeof window.fetch === 'function' ? window.fetch.bind(window) : null);
    if (!fetchImpl) {
      throw new Error('SearchGateway requires a fetch implementation');
    }
    this.fetch = fetchImpl;
    this.apiBase = typeof apiBase === 'string' && apiBase ? apiBase : inferApiBase();
    this.endpoint = endpoint;
  }

  async searchChats(query) {
    const trimmed = typeof query === 'string' ? query.trim() : '';
    if (!trimmed) {
      return [];
    }

    const response = await this.fetch(`${this.apiBase}${this.endpoint}`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: trimmed }),
    });

    if (!response || !response.ok) {
      const status = response ? response.status : 'network-error';
      throw new Error(`SearchGateway searchChats failed (${status})`);
    }

    return typeof response.json === 'function' ? response.json() : [];
  }
}

if (typeof window !== 'undefined') {
  window.AgileProGateways = window.AgileProGateways || {};
  window.AgileProGateways.SearchGateway = SearchGateway;
}
